import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './components/AuthProvider';
import { NotificationProvider } from './context/NotificationContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import AuthModals from './components/AuthModals';
import AdminDashboard from './components/AdminDashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import CivilLaw from './components/CivilLaw';
import LegalResources from './components/LegalResources';
import LocationServices from './components/LocationServices';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

// PWA Service Worker Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, show update notification
                if (window.confirm('New version available! Reload to update?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const HomePage = () => {
  const { user } = useContext(AuthContext) || { user: null };
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showBooking, setShowBooking] = useState(false);

  // Redirect admin users to dashboard
  useEffect(() => {
    if (user && user.role === 'admin') {
      window.location.href = '/admin';
    }
  }, [user]);

  return (
    <>
      <Header 
        onOpenLogin={() => setShowLogin(true)}
        onOpenSignup={() => setShowSignup(true)}
      />
      <Hero onOpenBooking={() => setShowBooking(true)} />
      <Services onOpenBooking={() => setShowBooking(true)} />
      <HowItWorks />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
      <InstallPrompt />
      <BookingModal 
        isOpen={showBooking}
        onClose={() => setShowBooking(false)}
      />
      <AuthModals 
        showLogin={showLogin}
        showSignup={showSignup}
        onCloseLogin={() => setShowLogin(false)}
        onCloseSignup={() => setShowSignup(false)}
        onOpenSignup={() => setShowSignup(true)}
        onOpenLogin={() => setShowLogin(true)}
      />
    </>
  );
};

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Temporarily disabled for testing
  // const { user } = useContext(AuthContext) || { user: null };
  
  // if (!user) {
  //   return <Navigate to="/" replace />;
  // }
  
  // if (user.role !== 'admin') {
  //   return <Navigate to="/" replace />;
  // }
  
  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/civil-law" element={<CivilLaw />} />
              <Route path="/legal-resources" element={<LegalResources />} />
              <Route path="/location-services" element={<LocationServices />} />
              <Route path="/criminal-law" element={<CivilLaw />} />
              <Route path="/matrimonial-law" element={<CivilLaw />} />
              <Route path="/arbitration" element={<CivilLaw />} />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
